
function transformTable(table) {
  const rows = table.querySelectorAll("tr");
  const data = [];

  rows.forEach((row, rowIndex) => {
    const cells = Array.from(row.children);

    cells.forEach((cell, colIndex) => {
      if (!data[colIndex]) data[colIndex] = [];
      data[colIndex][rowIndex] = cell.cloneNode(true);
    });
  });

  table.innerHTML = "";
  const tbody = document.createElement("tbody");

  data.forEach((newRowCells, rowIndex) => {
    const newRow = document.createElement("tr");
    newRowCells.forEach((cell, colIndex) => {
      newRow.appendChild(cell);
    });
    tbody.appendChild(newRow);
  });

  table.appendChild(tbody);
}

/* */
const iconMap = { 
                'Size': 'https://cdn.shopify.com/s/files/1/0155/8131/files/size.png', 
                'Weight': 'https://cdn.shopify.com/s/files/1/0155/8131/files/weight.png',
                'Material': 'https://cdn.shopify.com/s/files/1/0155/8131/files/care.png',
                'Care': 'https://cdn.shopify.com/s/files/1/0155/8131/files/care.png',
                'Colour': 'https://cdn.shopify.com/s/files/1/0155/8131/files/color_d7bf1ad5-fb06-4e91-93fe-dec6829008b5.png',
              }


/********************************************************
 Quick View Popup
 ********************************************************/

function loadQuickViewButtons() {
  const modal = document.getElementById('quick-view-modal');
  if (!modal) return;
  const closeModal = modal.querySelector('.close-modal');
  const addToCartButton = modal.querySelector('.qv-add-button');

  // Helper: find nearest scrollable ancestor
  function getScrollableAncestor(el) {
    let parent = el.parentElement;
    while (parent && parent !== document.body) {
      const style = window.getComputedStyle(parent);
      const overflowY = style.overflowY;
      if ((overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') && parent.scrollHeight > parent.clientHeight) {
        return parent;
      }
      parent = parent.parentElement;
    }
    // fallback to page scrolling element
    return document.scrollingElement || document.documentElement;
  }

  // Helper: scroll target element into view relative to ancestor
  function scrollElementToTopWithinAncestor(target, ancestor, offset = 8) {
    if (!target) return;
    // Wait for layout to settle
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!ancestor) {
          target.scrollIntoView({ behavior: 'auto', block: 'start' });
          return;
        }

        // If ancestor is the document scrolling element, use window.scrollTo
        const docEl = document.scrollingElement || document.documentElement;
        if (ancestor === docEl || ancestor === document.body || ancestor === document.documentElement) {
          const top = window.pageYOffset + target.getBoundingClientRect().top - offset;
          window.scrollTo({ top, behavior: 'auto' });
          return;
        }

        // Otherwise compute offset inside ancestor and scroll it
        const targetRect = target.getBoundingClientRect();
        const ancestorRect = ancestor.getBoundingClientRect();
        const ancestorScrollTop = ancestor.scrollTop;
        const desiredTop = ancestorScrollTop + (targetRect.top - ancestorRect.top) - offset;
        ancestor.scrollTo({ top: desiredTop, behavior: 'auto' });
      });
    });
  }

  // NEW: reset scrollTop for modal and all scrollable descendants
  function resetModalScrollPositions() {
    try {
      // Reset modal itself
      if (typeof modal.scrollTop !== 'undefined') {
        modal.scrollTop = 0;
        if (modal.scrollTo) modal.scrollTo({ top: 0, behavior: 'auto' });
      }
    } catch (e) { /* ignore */ }

    // Reset any scrollable descendants
    const all = modal.querySelectorAll('*');
    all.forEach(el => {
      try {
        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        if ((overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') && el.scrollHeight > el.clientHeight) {
          el.scrollTop = 0;
          if (el.scrollTo) el.scrollTo({ top: 0, behavior: 'auto' });
        }
      } catch (err) { /* ignore cross-origin or read errors */ }
    });
  }

  // NEW: destroy previously created Swiper instances (if any) stored on modal
  function destroyExistingSwipers() {
    try {
      if (modal._qv_main_swiper && typeof modal._qv_main_swiper.destroy === 'function') {
        modal._qv_main_swiper.destroy(true, true);
      }
    } catch (e) {}
    try {
      if (modal._qv_thumbs_swiper && typeof modal._qv_thumbs_swiper.destroy === 'function') {
        modal._qv_thumbs_swiper.destroy(true, true);
      }
    } catch (e) {}
    modal._qv_main_swiper = null;
    modal._qv_thumbs_swiper = null;
  }

  // Called whenever modal is shown: scroll to title
  function ensureTitleVisible() {
    // Detect mobile vs desktop
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    // Selector logic
    const selector = isMobile ? "#qv-image" : "#qv-title";
    const title = modal.querySelector(selector);
    if (!title) return;
    const ancestor = getScrollableAncestor(title);
    scrollElementToTopWithinAncestor(title, ancestor, 6);
  }

  // If some other code toggles the modal visibility via class change, observe it
  const modalObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.attributeName === 'class') {
        const hasShow = modal.classList.contains('show');
        if (hasShow) {
          // ensure title visible on show
          ensureTitleVisible();
        }
      }
    }
  });
  modalObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });

  // Main click handler that opens quick view
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('.quick-view');
    if (!button) return;

    document.querySelector('html').classList.add('CP-qv-open');
    document.querySelector('html').classList.remove('CP-rv-open');

    let productData;
    try {
      productData = JSON.parse(button.getAttribute('data-product'));
    } catch (err) {
      console.error('Invalid product JSON on quick-view button', err);
      return;
    }

    // Fallback: If only 1 variant is present, fetch full product JSON
    if (productData?.variants?.length === 1 && productData.url) {
      const handleMatch = productData.url.match(/\/products\/([^/?#]+)/);
      const handle = handleMatch?.[1];
      if (handle) {
        try {
          const res = await fetch(`/products/${handle}.js`);
          const fullData = await res.json();
          if (fullData?.variants?.length > 1) productData = fullData;
        } catch (err) {
          console.warn('Fallback product fetch failed:', err);
        }
      }
    }

    // attach the productData to addToCartButton for later
    if (addToCartButton) addToCartButton.productData = productData;

    // NEW: reset any previous scroll positions and destroy old swipers BEFORE showing new content
    resetModalScrollPositions();
    destroyExistingSwipers();

    // Show modal
    modal.classList.remove('hidden');
    modal.classList.add('show', 'cp_modal_loading');

    // Populate basic fields synchronously
    modal.querySelector('.qv-product-title').textContent = productData.title || '';
    modal.querySelector('.qv-product-type').textContent = productData.type || '';
    modal?.querySelector('a.view-product')?.setAttribute('href', productData?.url ?? '#'  );

    const currentCurrenctSign = document.querySelector('.footer select.currency-switcher')?.value;
    const currentCard = e.target.closest('.recently-box') || e.target.closest('.CP-recentlyViewedDrawer .CP-drawer-product-card') || 
                        e.target.closest('.collection .product-card-wrapper .card') || e.target.closest('.st-product-wrapper .st-product-wrap');
    let currentCardPrice = null;
    if (currentCard) {
      currentCardPrice = currentCard.querySelector(".price__regular .price-item--regular")?.textContent?.trim() 
            || currentCard.querySelector(".CP-drawer-price-info")?.textContent?.trim() || currentCard.querySelector(".new-price.money")?.textContent?.trim();
    }
    modal.querySelector('.qv-product-price').setAttribute('doubly-currency', currentCurrenctSign || '');
    modal.querySelector('.qv-product-price').textContent = currentCardPrice || '';

    // scroll to title now that title exists and modal is shown
    ensureTitleVisible();

    // Begin loading async details (description, size chart, images, variants, stock)
    const isFabric = productData.type && productData.type.toLowerCase() === 'fabrics';
    const orig = modal.querySelector('.qv-product-original-price');

    // Price / compare at
    const compareAtPrice = productData.variants?.[0]?.compare_at_price;
    if (typeof compareAtPrice !== 'undefined' && compareAtPrice > productData.variants[0].price) {
      const baseComparePrice = compareAtPrice / 100;
      orig.textContent = `₹${(isFabric ? baseComparePrice * 2 : baseComparePrice).toFixed(0)}${isFabric ? '/meter' : ''}`;
      orig.style.display = 'block';
    } else {
      orig.style.display = 'none';
    }

    // stock progress
    (function updateStock() {
      const progessBarContainer = modal.querySelector('.qv-product-stock');
      if (productData.variants?.length > 0 && progessBarContainer) {
        const remainingStock = productData.variants.reduce(
          (sum, variant) => sum + (Number(variant.inventory_quantity) || 0),
          0
        );
        const totalStock = remainingStock + 50;
        const progressPercent = (remainingStock / totalStock) * 100;
        const fill = modal.querySelector(".qv-progress-fill");
        const count = modal.querySelector(".qv-stock-count");
        const progressBar = modal.querySelector(".qv-progress-bar");

        if (fill) fill.style.width = `${progressPercent}%`;
        if (remainingStock < 4 && fill) fill.style.backgroundColor = "#EA3E41";
        if (count) count.textContent = remainingStock;
      }
    })();

    // variants UI (single-option flow kept similar)
    (function buildVariants() {
      const variantBox = modal.querySelector('.qv-product-options');
      if (!variantBox) return;
      variantBox.innerHTML = '';
      const isSingleOption = productData.variants.every(v => v.option2 === null && v.option3 === null);
      if (isSingleOption) {
        const variants = productData.variants.map(v => v.option1).filter(v => v !== 'Default Title');
        if (variants.length > 0) {
          const container = document.createElement('div');
          container.innerHTML = `<span>Select Size</span><div class="qv-variant-options"></div>`;
          const variantWrapper = container.querySelector('.qv-variant-options');
          [...new Set(variants)].forEach(opt => {
            const btn = document.createElement('button');
            btn.className = 'qv-variant-btn';
            btn.dataset.value = opt;
            btn.textContent = opt;

            const variant = productData.variants.find(v => v.option1 === opt);
            const isSoldOut = variant && variant.inventory_quantity <= 0;

            if (isSoldOut) {
              btn.classList.add('sold-out');
              btn.disabled = true;
              btn.style.textDecoration = 'line-through';
              btn.style.opacity = '0.5';
            } else {
              btn.onclick = () => {
                modal.querySelectorAll('.qv-variant-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                const selectedVariant = productData.variants.find(v => v.option1 === opt) || productData.variants[0];
                const variantPrice = selectedVariant.price / 100;
                modal.querySelector('.qv-product-price').textContent = `₹${(isFabric ? variantPrice * 2 : variantPrice).toFixed(0)}${isFabric ? '/meter' : ''}`;
                if (selectedVariant.compare_at_price > selectedVariant.price) {
                  const variantComparePrice = selectedVariant.compare_at_price / 100;
                  orig.textContent = `₹${(isFabric ? variantComparePrice * 2 : variantComparePrice).toFixed(0)}${isFabric ? '/meter' : ''}`;
                  orig.style.display = 'block';
                } else {
                  orig.style.display = 'none';
                }
                addToCartButton.selectedVariant = selectedVariant;
              };
            }
            variantWrapper.appendChild(btn);
          });
          variantBox.appendChild(container);

          // Select first available
          const firstAvailableBtn = variantWrapper.querySelector('.qv-variant-btn:not(.sold-out)');
          if (firstAvailableBtn) {
            firstAvailableBtn.classList.add('active');
            const selectedVariant = productData.variants.find(v => v.option1 === firstAvailableBtn.dataset.value) || productData.variants[0];
            addToCartButton.selectedVariant = selectedVariant;
          } else {
            addToCartButton.selectedVariant = productData.variants[0];
          }
        } else {
          addToCartButton.selectedVariant = productData.variants[0];
        }
      } else {
        // multi-option form (kept same structure)
        const form = document.createElement('div');
        form.className = 'qv-variant-form';
        productData.options.forEach((optName, index) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'qv-variant-group';
          const label = document.createElement('label');
          label.textContent = optName;
          wrapper.appendChild(label);
          const optValues = [...new Set(productData.variants.map(v => v[`option${index + 1}`]).filter(v => v))];
          let isFirst = true;
          optValues.forEach(val => {
            const inputId = `qv-opt-${index}-${val.replace(/\s/g, '-')}`;
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = `option${index + 1}`;
            input.value = val;
            input.id = inputId;
            if (isFirst) {
              input.checked = true;
              isFirst = false;
            }
            input.onclick = () => {
              const selectedOptions = [];
              productData.options.forEach((_, i) => {
                const selectedInput = modal.querySelector(`input[name="option${i + 1}"]:checked`);
                selectedOptions[i] = selectedInput?.value || null;
              });
              const selectedVariant = productData.variants.find(v =>
                selectedOptions.every((opt, i) => opt === v[`option${i + 1}`])
              ) || productData.variants[0];
              const variantPrice = selectedVariant.price / 100;
              modal.querySelector('.qv-product-price').textContent = `₹${(isFabric ? variantPrice * 2 : variantPrice).toFixed(0)}${isFabric ? '/meter' : ''}`;
              if (selectedVariant.compare_at_price > selectedVariant.price) {
                const variantComparePrice = selectedVariant.compare_at_price / 100;
                orig.textContent = `₹${(isFabric ? variantComparePrice * 2 : variantComparePrice).toFixed(0)}${isFabric ? '/meter' : ''}`;
                orig.style.display = 'block';
              } else {
                orig.style.display = 'none';
              }
              addToCartButton.selectedVariant = selectedVariant;
            };
            const lbl = document.createElement('label');
            lbl.setAttribute('for', inputId);
            lbl.textContent = val;
            wrapper.appendChild(input);
            wrapper.appendChild(lbl);
          });
          form.appendChild(wrapper);
        });
        variantBox.appendChild(form);
        // initial selected variant
        const selectedOptions = [];
        productData.options.forEach((_, i) => {
          const selectedInput = modal.querySelector(`input[name="option${i + 1}"]:checked`);
          selectedOptions[i] = selectedInput?.value || null;
        });
        const selectedVariant = productData.variants.find(v =>
          selectedOptions.every((opt, i) => opt === v[`option${i + 1}`])
        ) || productData.variants[0];
        addToCartButton.selectedVariant = selectedVariant;
      }
    })();

    // Quantity UI (kept your existing logic)
    (function buildQuantity() {
      const qtyDiv = modal.querySelector('.qv-quantity-wrapper');
      if (!qtyDiv) return;
      qtyDiv.innerHTML = '';
      const qtyLabel = document.createElement('span');
      qtyLabel.textContent = isFabric ? 'Select Length' : 'Quantity';
      qtyDiv.appendChild(qtyLabel);

      const maxQty = parseInt(productData.variants?.[0]?.inventory_quantity || 20, 10);

      // Two supported flows: qty_dropdown or default numeric box (kept same)
      if (productData.qty_dropdown && Array.isArray(productData.qty_dropdown) && productData.qty_dropdown.length > 0) {
        const dropdown = document.createElement('div');
        dropdown.className = 'qty_dropdown';
        const selector = document.createElement('p');
        selector.className = 'qty_selector';
        selector.innerHTML = `<span>${productData.qty_dropdown[0]}</span>
          <svg width="15" height="15" viewBox="0 0 386.257 386.257"><polygon points="0,96.879 193.129,289.379 386.257,96.879"/></svg>`;
        dropdown.appendChild(selector);
        const panel = document.createElement('div');
        panel.className = 'qty_panel';
        panel.style.display = 'none';
        panel.style.maxHeight = '240px';
        panel.style.overflowY = 'auto';
        productData.qty_dropdown.forEach((val, idx) => {
          const p = document.createElement('p');
          p.setAttribute('data-value', val);
          p.textContent = val;
          if (idx === 0) p.classList.add('active');
          p.onclick = () => {
            modal.querySelectorAll('.qty_panel p').forEach(e => e.classList.remove('active'));
            p.classList.add('active');
            selector.querySelector('span').textContent = val;
            panel.style.display = 'none';
          };
          panel.appendChild(p);
        });
        selector.onclick = () => {
          panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
        };
        dropdown.appendChild(panel);
        qtyDiv.appendChild(dropdown);
      } else if (isFabric) {
        const dropdown = document.createElement('div');
        dropdown.className = 'qty_dropdown';
        const selector = document.createElement('p');
        selector.className = 'qty_selector';
        selector.innerHTML = `<span>0.5 meter</span>
          <svg width="15" height="15" viewBox="0 0 386.257 386.257"><polygon points="0,96.879 193.129,289.379 386.257,96.879"/></svg>`;
        dropdown.appendChild(selector);
        const panel = document.createElement('div');
        panel.className = 'qty_panel';
        panel.style.display = 'none';
        panel.style.maxHeight = '240px';
        panel.style.overflowY = 'auto';
        for (let i = 1; i <= maxQty; i++) {
          const p = document.createElement('p');
          const meterVal = (i / 2).toFixed(1);
          p.setAttribute('data-value', i);
          p.textContent = `${meterVal} meter`;
          if (i === 1) p.classList.add('active');
          p.onclick = () => {
            modal.querySelectorAll('.qty_panel p').forEach(e => e.classList.remove('active'));
            p.classList.add('active');
            selector.querySelector('span').textContent = `${meterVal} meter`;
            panel.style.display = 'none';
          };
          panel.appendChild(p);
        }
        selector.onclick = () => {
          panel.style.display = panel.style.display === 'none' ? 'block' : 'none';
        };
        dropdown.appendChild(panel);
        qtyDiv.appendChild(dropdown);
      } else {
        const box = document.createElement('div');
        box.className = 'qty-box';
        box.innerHTML = `
          <button class="qty-minus">−</button>
          <input type="number" class="qv-quantity" value="1" min="1">
          <button class="qty-plus">+</button>
        `;
        box.querySelector('.qty-minus').onclick = () => {
          const input = box.querySelector('.qv-quantity');
          input.value = Math.max(1, parseInt(input.value, 10) - 1);
        };
        box.querySelector('.qty-plus').onclick = () => {
          const input = box.querySelector('.qv-quantity');
          input.value = parseInt(input.value, 10) + 1;
        };
        qtyDiv.appendChild(box);
      }

      // Hide when clicking outside any dropdown
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.qty_dropdown')) {
          modal.querySelectorAll('.qty_panel').forEach(panel => panel.style.display = 'none');
        }
      });
    })();

    // Fetch the product page html for description and size chart (kept your logic)
    const descPromise = fetch(productData.url).then(res => res.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const descHTML = doc.querySelector('.accordion-panel.description.productDetail');
      const descContainer = modal.querySelector('.qv-product-description');

      const stockEl = doc.querySelector('.CP-stock-status');
      const customEl = doc.querySelector('.CP-custom-text');
      const stockInfo = (stockEl ? stockEl.outerHTML : '') + (customEl ? customEl.outerHTML : '');
      modal.querySelector('.qv-product-stock').innerHTML = stockInfo || '';

      descContainer.innerHTML = '';
      if (descHTML) {
        const descClone = descHTML.cloneNode(true);
        descClone.querySelectorAll('style, script').forEach(el => el.remove());
        // transform each table into key-value pairs as per your previous logic
        descClone.querySelectorAll('table').forEach(table => {
          const fragment = document.createDocumentFragment();
          table.querySelectorAll('tr').forEach(row => {
            const cells = row.querySelectorAll('th, td');
            if (cells.length >= 2) {
              const title = cells[0].innerText.trim();
              const content = cells[1].innerText.trim();
              const titleEl = document.createElement('strong');
              titleEl.style.color = '#f9af36';
              titleEl.textContent = title;
              const contentEl = document.createElement('p');
              contentEl.textContent = content;
              fragment.appendChild(titleEl);
              fragment.appendChild(contentEl);
            }
          });
          table.parentNode.replaceChild(fragment, table);
        });
        descContainer.appendChild(descClone);

        const iconMap = {
          'Size': 'https://cdn.shopify.com/s/files/1/0155/8131/files/size.png',
          'Weight': 'https://cdn.shopify.com/s/files/1/0155/8131/files/weight.png',
          'Material': 'https://cdn.shopify.com/s/files/1/0155/8131/files/care.png',
          'Care': 'https://cdn.shopify.com/s/files/1/0155/8131/files/care.png',
          'Colour': 'https://cdn.shopify.com/s/files/1/0155/8131/files/color_d7bf1ad5-fb06-4e91-93fe-dec6829008b5.png'
        };

        descContainer.querySelectorAll('strong').forEach((el) => {
          const key = el.textContent.trim();
          if (iconMap[key]) {
            const wrapper = document.createElement("div");
            wrapper.classList.add('qv-item-wrapper');
            const img = document.createElement("img");
            img.src = iconMap[key];
            img.alt = key;
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(img);
            wrapper.appendChild(el);
          }
        });
      } else {
        descContainer.innerHTML = `<p>Description not available.</p>`;
      }
    });

    const sizeChartPromise = fetch(productData.url).then(res => res.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sizeChartContainer = modal.querySelector('.qv-size-chart-container');
      if (!sizeChartContainer) return;
      sizeChartContainer.innerHTML = '';
      const sizeChart = doc.querySelector('.size-chart .size-chart-bottom .size-chart-guide');
      if (!sizeChart) return;
      sizeChartContainer.innerHTML = sizeChart.outerHTML;

      // wire up inches/cm toggles and table transforms as before
      const labelInches = sizeChartContainer.querySelector('label[for="inches-table"]');
      const labelCM = sizeChartContainer.querySelector('label[for="cm-table"]');
      const tableInches = sizeChartContainer.querySelectorAll('table#inches-table');
      const tableCM = sizeChartContainer.querySelectorAll('table#cm-table');
      tableInches.forEach(t => t.style.display = 'block');
      tableCM.forEach(t => t.style.display = 'none');
      if (labelInches && labelCM) {
        labelInches.classList.add('CP-label-active');
        labelCM.classList.add('CP-label-inactive');
        labelInches.addEventListener('click', () => {
          tableInches.forEach(t => t.style.display = 'block');
          tableCM.forEach(t => t.style.display = 'none');
          labelInches.classList.add('CP-label-active');
          labelCM.classList.remove('CP-label-active');
        });
        labelCM.addEventListener('click', () => {
          tableCM.forEach(t => t.style.display = 'block');
          tableInches.forEach(t => t.style.display = 'none');
          labelCM.classList.add('CP-label-active');
          labelInches.classList.remove('CP-label-active');
        });
      }

      // transform table helper (kept from your original)
      function transformTable(table) {
        const rows = table.querySelectorAll("tr");
        const data = [];
        rows.forEach((row, rowIndex) => {
          const cells = Array.from(row.children);
          cells.forEach((cell, colIndex) => {
            if (!data[colIndex]) data[colIndex] = [];
            data[colIndex][rowIndex] = cell.cloneNode(true);
          });
        });
        table.innerHTML = "";
        const tbody = document.createElement("tbody");
        data.forEach((newRowCells) => {
          const newRow = document.createElement("tr");
          newRowCells.forEach((cell) => {
            newRow.appendChild(cell);
          });
          tbody.appendChild(newRow);
        });
        table.appendChild(tbody);
      }

      const containers = sizeChartContainer.querySelectorAll(".ovevrflowChart");
      containers.forEach((container) => {
        const tables = container.querySelectorAll("table[id]");
        tables.forEach((table) => {
          transformTable(table);
        });
      });
    });

    // Images / Swiper
    const imagesDiv = modal.querySelector('.qv-product-images');
    const slides = (productData.images || []).map(img => {
      const src = typeof img === 'string' ? img : img.src;
      return `<div class="swiper-slide"><img src="${src}" /></div>`;
    }).join('');
    imagesDiv.innerHTML = `
      <div class="swiper qv-main-swiper"><div class="swiper-wrapper">${slides}</div></div>
      <div class="qv-thumbs-wrapper">
        <div class="qv-thumb-prev">‹</div>
        <div class="swiper qv-thumbs-swiper"><div class="swiper-wrapper">${slides}</div></div>
        <div class="qv-thumb-next">›</div>
      </div>`;

    // Initialize Swiper
    if (typeof Swiper !== 'undefined') {
      // Ensure old Swipers are destroyed (safety)
      destroyExistingSwipers();

      // Thumbs Swiper
      const thumbsSwiper = new Swiper('.qv-thumbs-swiper', {
        spaceBetween: 5,
        slidesPerView: 4,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.qv-thumb-next',
          prevEl: '.qv-thumb-prev',
        },
        breakpoints: {
          0: {
            slidesPerView: 4,
            slidesPerGroup: 1,
          },
          480: {
            slidesPerView: 5,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 6,
            slidesPerGroup: 2,
            freeMode: true,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 8,
            slidesPerGroup: 2,
            freeMode: true,
            spaceBetween: 10,
          },
          1280: {
            slidesPerView: 10,
            slidesPerGroup: 2,
            freeMode: true,
            spaceBetween: 10,
          },
        },
      });
      // Main Swiper
      const mainSwiper = new Swiper('.qv-main-swiper', {
        spaceBetween: 10,
        thumbs: {
          swiper: thumbsSwiper,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          1024: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
        },
      });

      // store references on modal so we can destroy/reset them next time
      modal._qv_thumbs_swiper = thumbsSwiper;
      modal._qv_main_swiper = mainSwiper;

      // Reset Swiper to first slide to avoid preserved position
      try {
        mainSwiper.slideTo(0, 0);
        thumbsSwiper.slideTo(0, 0);
      } catch (e) {}
    }

    Promise.all([descPromise, sizeChartPromise]).finally(() => {
      modal.classList.remove('cp_modal_loading');
      // ensure title visible after async content has been inserted
      ensureTitleVisible();
      // also reset modal scroll positions one more time (safety)
      resetModalScrollPositions();
    });

  }); // end click handler

  // add-to-cart click
  if (addToCartButton) {
    addToCartButton.onclick = () => {
      addToCartButton.classList.add('loading');
      addToCartButton.querySelector('.loading__spinner')?.classList.remove('hidden');

      const productData = addToCartButton.productData;
      let qty = 1;
      const qtyDropdown = modal.querySelector('.qty_panel p.active');
      if (qtyDropdown) {
        qty = parseInt(qtyDropdown.getAttribute('data-value'), 10);
      } else {
        const qtyInput = modal.querySelector('.qv-quantity');
        if (qtyInput) qty = parseInt(qtyInput.value, 10);
      }
      if (isNaN(qty) || qty < 1) {
        alert('Please select a valid quantity.');
        return;
      }
      const variant = addToCartButton.selectedVariant || productData?.variants?.[0];
      if (!variant || !variant.id) {
        alert('Please select a valid variant.');
        return;
      }
      if (variant.inventory_quantity && qty > variant.inventory_quantity) {
        alert(`Only ${variant.inventory_quantity} available.`); 
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variant.id,
          quantity: qty,
          sections: ['cart-drawer', 'cart-icon-bubble']
        })
      }).then(res => res.json()).then(data => {
        modal.classList.remove('show');
        document.querySelector('html').classList.remove('CP-qv-open');
        document.querySelector('html').classList.remove('CP-rv-open');

        // reset scroll positions & destroy swipers as we closed the modal
        resetModalScrollPositions();
        destroyExistingSwipers();

        // handle drawer update (best-effort)
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          drawer.classList.remove('is-empty');
          drawer.open();
        } else {
          fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(res => res.json())
            .then(sections => {
              if (drawer && sections['cart-drawer']) {
                drawer.innerHTML = sections['cart-drawer'];
                drawer.classList.remove('is-empty');
                drawer.open();
              }
              const bubble = document.querySelector('.cart-icon-bubble');
              if (bubble && sections['cart-icon-bubble']) {
                bubble.innerHTML = sections['cart-icon-bubble'];
              }
            }).catch(()=>{});
        }
      }).catch(err => alert('Failed to add to cart: ' + (err.message || err)));
      setTimeout(() => {
        addToCartButton.classList.remove('loading');
        addToCartButton.querySelector('.loading__spinner')?.classList.add('hidden');
      }, 2700);
    };
  }

  // close modal handlers
  if (closeModal) {
    closeModal.onclick = () => {
      modal.classList.remove('show');
      document.querySelector('html').classList.remove('CP-qv-open');
      document.querySelector('html').classList.remove('CP-rv-open');

      // reset scroll positions & destroy Swipers so a later open starts fresh
      resetModalScrollPositions();
      destroyExistingSwipers();
    };
  }

  window.addEventListener('click', e => {
    if (e.target === modal) {
      document.querySelector('html').classList.remove('CP-qv-open');
      document.querySelector('html').classList.remove('CP-rv-open');
      modal.classList.remove('show');

      // reset scroll positions & destroy Swipers
      resetModalScrollPositions();
      destroyExistingSwipers();
    }
  });
}

document.addEventListener('DOMContentLoaded', loadQuickViewButtons);
